module.exports = __webpack_public_path__ + "static/media/chevron-right.992a01aa.svg";